import { generatePath } from "@routes/utils.ts";
import type { IExtractParams } from "@routes/types.ts";

const pathBase = `/files/upload/`;
const pathById = `${pathBase}:fileId/`;

export type IFilePathParam = IExtractParams<typeof pathById>;

export const file = {
  post: () => generatePath(pathBase, null),
  get: (param: IFilePathParam) => generatePath(pathById, param),
};
